import Link from "next/link";

const UserImpersonate = ({
  userProfileName,
  impersonatorName,
}: {
  userProfileName: string;
  impersonatorName: string;
}) => (
  <div className="p-1 flex flex-col items-center bg-[rgba(0,0,0,.2)] text-[12px]">
    <span>
      Hello{" "}
      <Link href="/account/profile" className="text-[#ff8200] hover:underline">
        {userProfileName}
      </Link>
    </span>
    <span>You are being served by {impersonatorName}</span>
  </div>
);

export default UserImpersonate;
